import { useQuery } from '@tanstack/react-query';
import type { MeResponse } from '@lyra/shared';
import { apiFetch } from './apiClient';
import { queryKeys } from './queryKeys';

/** The single source of org/role/permission context for the shell + guards.
 *  Returns `undefined` while loading or when unauthenticated (the /me call
 *  401s → ApiClientError → the guard treats "no data" as logged-out). */
export function useMe() {
  return useQuery<MeResponse>({
    queryKey: queryKeys.me,
    queryFn: () => apiFetch<MeResponse>('/me'),
    retry: false,
  });
}
